<template>
    <div class="class-list p-b-64 page">
        <div v-if="indicatorType" style="height: 80vh; display: flex; flex-direction: row; align-items: center">
            <indicatorEmpty :type="indicatorType" :message="indicatorMessage"></indicatorEmpty>
        </div>
        <div v-if="!indicatorType">
            <div style="padding-bottom: 60px; text-align: left">
                <div style="font-size: 14px; text-align: left; position: relative;">
                    <div class="approve-detail-head" v-show="form && form.length">
                        <img class="approve-detail-head--portrait"
                             :src="data.userDetails ? data.userDetails[data.profileId].portraitImgUrl : ''">
                        <div>
                            <div style="align-items: baseline">
                                <span style="font-size: 17px">{{data.userDetails ? data.userDetails[data.profileId].realName : ''}}</span>
                                <span v-if="data.statusCd == 1" style="margin-left: 10px"
                                      class="approve-pending-color">等待审批</span>
                                <span v-else-if="data.statusCd == 5" style="margin-left: 10px"
                                      class="approve-withdrawn-color">已撤回</span>
                            </div>
                            <div style="margin-top: 8px">
                                <span style="font-size: 14px;">{{data.userDetails ? data.userDetails[data.profileId].fullDepPathName : ''}}</span>
                            </div>
                            <div style="margin-top: 8px">
                                <span>审批编号：</span>
                                <span>{{data.seqNo}}</span>
                            </div>
                            <div style="position: absolute;right: 15px; top: 20px;">
                                <img v-if="data.statusCd == 2" src="../../assets/img/detail/已驳回.png"
                                     style="height: 36px">
                                <img v-if="data.statusCd == 3" src="../../assets/img/detail/已通过.png"
                                     style="height: 36px">
                                <!--<img v-if="data.statusCd == 4" src="../../assets/img/detail/已驳回.png"-->
                                <!--style="height: 36px">-->
                            </div>
                        </div>
                    </div>
                    <div style="margin-top: 10px">
                        <div
                            v-for="(cmpt, i) in form"
                            :key="i">
                            <detailCompnents :cmpt="cmpt"></detailCompnents>
                        </div>
                    </div>

                </div>
                <div v-show="form && form.length">
                    <div class="approve-detail-process">
                        <yd-timeline>
                            <yd-timeline-item v-for="(flow,i) in rules"
                                              :key="i">
                                <div slot="icon">
                                    <img class="portrait-shape portrait-size-40"
                                         @click="showProcessInfo(flow)"
                                         :src="getProcessPortrait(flow)">
                                </div>
                                <div class="approve-detail-process--text">
                                    <div v-if="flow.remark" class="approve-detail-process--mark">{{flow.remark}}</div>
                                    <div>
                                        <span style="color: #ff9e00" v-if="flow.type == 7">归档</span>
                                        <span v-else>
                                        <span>{{getProcessName(flow)}}</span>
                                        <span style="margin-left: 10px">
                                            <span v-if="flow.type == 1">发起申请</span>
                                            <span class="approve-pending-color"
                                                  v-else-if="flow.isNow">
                                                <span v-if="flow.approvals.length == 1">审批中</span>
                                                <span v-else-if="flow.actType == 'or'">或签中</span>
                                                <span v-else-if="flow.actType == 'and'">会签中</span>
                                                <span v-else>或签中</span>
                                            </span>
                                            <span class="approve-agree-color"
                                                  v-else-if="flow.type == 2">已同意</span>
                                            <span class="approve-reject-color"
                                                  v-else-if="flow.type == 3">已拒绝</span>
                                            <span class="approve-withdrawn-color"
                                                  v-else-if="flow.type == 4">已撤回</span>
                                            <span v-else-if="flow.type == 5">添加评论</span>
                                            <span v-else-if="flow.type == 6">编辑了审批单</span>
                                        </span>
                                    </span>
                                    </div>
                                    <div class="approve-detail-process--time">{{calculateWait(i)}}</div>
                                    <div v-if="flow.approvals.length > 1"
                                         class="approve-detail-process--duoren">
                                        <span v-if="flow.actType=='or'">以下成员一人审批即可</span>
                                        <span v-else-if="flow.actType=='and'">须以下所有人审批通过</span>
                                        <span v-else>以下成员一人审批即可</span>
                                        <div
                                            style="display: flex; flex-direction: row; align-items: center;margin-top: 10px"
                                            v-for="(aitem, i) in flow.approvals"
                                            :key="i">
                                            <img class="portrait-shape portrait-size-40"
                                                 @click="showUserInfo(aitem)"
                                                 :src="getPortrait(aitem)">
                                            <span style="margin-left: 10px; color: #28405E; font-size: 14px">{{getNotifierName(aitem)}}</span>
                                        </div>
                                    </div>

                                    <div
                                        v-if="flow.content && (!data.temp.opinionHide || !(flow.type == 2 || flow.type == 3) || (isHistoryApprover || isApprover))"
                                        style="color: #596C83; margin-top: 10px">{{flow.content}}
                                    </div>
                                </div>
                            </yd-timeline-item>
                        </yd-timeline>
                    </div>
                    <div v-if="forwardToMeList.length > 0" style="margin-top: 10px">
                        <van-cell
                            title="转发给我"
                            :required="false">
                        </van-cell>
                        <ul style="font-size: 15px;background-color: white; padding: 15px">
                            <li v-for="(forward, index) in forwardToMeList" :key="index">
                                <div :style="{'padding-top': index > 0 ? '15px' : '0px'}">
                                    <span style="color: #077ffa" @click="showUserInfo(forward.fromProfileId)">{{getNotifierName(forward.fromProfileId)}}</span>
                                    <span> 在 </span>
                                    <span style="color: #eeaa55">{{forward.nodeName}}</span>
                                    <span> 节点转发给我</span>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div v-if="forwardFromMeList.length > 0" style="margin-top: 10px">
                        <van-cell
                            title="我转发的"
                            :required="false">
                        </van-cell>
                        <ul style="font-size: 15px;background-color: white; padding: 15px">
                            <li v-for="(forward, index) in forwardFromMeList" :key="index">
                                <div :style="{'padding-top': index > 0 ? '15px' : '0px'}">
                                    <span>我在 </span>
                                    <span style="color: #eeaa55">{{forward.nodeName}}</span>
                                    <span> 节点转发给 </span>
                                    <span style="color: #077ffa" @click="showUserInfo(forward.toProfileId)">{{getNotifierName(forward.toProfileId)}}</span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div style="margin-top: 10px;position: relative;">
                    <van-cell
                        title="流程图" v-show="flowData"
                        :required="false" v-if="form && form.length">
                    </van-cell>
                    <div class="mountNode" id="mountNode"
                         style="background-color: white;position: relative;"></div>
                </div>
            </div>
            <div v-if="(isApprover || (isFromMe && data.statusCd == 1) || canComment) && (form && form.length)"
                 class="approve-detail-bottom-layout">
                <img src="../../assets/img/detail/投影.png" style="width: 100%">
                <div class="approve-detail-bottom-layout--group">
                    <div v-if="isApprover" class="bottom-layout-btn--group--common bottom-layout-btn--group--agree"
                         @click="commit(true)">
                        <span>同意</span>
                    </div>
                    <div v-if="isApprover" class="bottom-layout-btn--group--other onepx-v" @click="commit(false)">
                        <img src="../../assets/img/detail/驳回.png" style="height: 20px; margin-top: 4px">
                        <div class="other-text">驳回</div>
                    </div>
                    <div v-if="isFromMe && data.statusCd == 1" class="bottom-layout-btn--group--other onepx-v"
                         @click="showDialog(3)">
                        <img src="../../assets/img/detail/撤销.png" style="height: 20px; margin-top: 4px">
                        <div class="other-text">撤销</div>
                    </div>
                    <div v-if="canComment" class="bottom-layout-btn--group--other onepx-v" @click="showDialog(4)">
                        <img src="../../assets/img/detail/评论.png" style="height: 20px; margin-top: 4px">
                        <div class="other-text">评论</div>
                    </div>
                </div>
            </div>
            <van-dialog
                v-model="dialogShow"
                show-cancel-button
                :title="dialogTitle"
                :before-close="beforeClose"
            >
                <van-field
                    style="padding-top: 15px"
                    v-if="dialogType == 4"
                    v-model="opinionComment"
                    type="textarea"
                    :placeholder="'评论'"
                />
                <!--<div style="text-align: left; padding: 15px 15px 15px 15px" v-if="dialogType == 3">你确定要撤销申请吗</div>-->
            </van-dialog>
        </div>
    </div>
</template>

<script>
    import detailCompnents from '../approve/detailCompnents';
    import head from '../../mixins/head';
    import _ from '../../helper/lodash';
    import indicatorEmpty from '../approve/empty';
    import G6 from '@antv/g6';
    import { registerNode } from '../../mixins/g6';
    import { Dialog } from 'vant';
    import componnetInitValue from '../../mixins/component';

    export default {
        components: {
            detailCompnents,
            indicatorEmpty
        },
        name: 'flow-detail',
        mixins: [head, componnetInitValue],
        data() {
            return {
                data: '',
                form: [], //显示的表单
                flowData: '',
                graph: '',
                editForm: [], //编辑的表单
                rules: [],
                result: {},
                isApprover: false, //是否是当前审批人
                isHistoryApprover: false, //是否是历史审批人
                isFromMe: false, //是否是我发起的
                isNotifier: false, //是否是抄送人
                isArchiver: false, //是否是归档人
                forwardFromMeList: [], //我转发的记录
                forwardToMeList: [], //转发给我的记录
                canComment: false, //是否可以评论
                dialogShow: false,
                dialogType: null,
                dialogTitle: '',
                opinionAgree: '',
                opinionRefuse: '',
                opinionComment: '',
                noticeType: '',
                indicatorType: 0,
                indicatorMessage: '',
                time: '',
                scaleValue: 1
            };
        },
        props: {
            data2: {
                type: Array,
                default: function () {
                    return [];
                }
            }
        },
        watch: {
            '$route': 'inited'
        },
        computed: {},
        created() {
            this.markRead();
        },
        mounted() {
            window.shareBtn = () => {
                let shareData = {
                    companyId: this.data.temp.companyId,
                    title: '审批：' + this.data.title || this.data.approveName,
                    content: '',
                    shareType: 'APP_URL',
                    shareUrl: window.location.href,
                    imgUrl: this.data.userDetails[this.data.profileId].portraitImgUrl
                };
                let shareContent = '';
                try {
                    shareContent += '发起人:' + this.data.userDetails[this.data.profileId].realName;
                    let showContent = JSON.parse(this.data.showContent);
                    for (let i = 0; i < showContent.length; i++) {
                        let item = showContent[i];
                        shareContent += '\n' + item.label + ':' + item.value;
                    }
                } catch (e) {
                    ;
                }
                shareData.content = shareContent;
                window.share(shareData);
            };

            window.submitAgain = () => {
                this.submitAgain();
            };

            window.forward = () => {
                window.pickUser(true, null, -1, true, { action: 'forward' });
            };

            window.returnValue = (vals, extra) => {
                console.log('returnValue', vals, extra);
                let extraData = JSON.parse(extra);
                if (extraData.returnType == 'pickUser' && extraData.action == 'forward' && vals && vals.length > 0) {
                    let users = JSON.parse(vals);
                    let names = '';
                    let ids = '';
                    for (let i = 0; i < users.length; i++) {
                        if (ids) {
                            names += ', ';
                            ids += ',';
                        }
                        names += users[i].realName;
                        ids += users[i].profileId;
                    }
                    Dialog.confirm({
                        title: '流程转发',
                        message: '确认将流程转发给' + names
                    }).then(() => {
                        this.forward(ids);
                    });
                }
            };

            this.inited();
        },
        beforeDestroy() {
            this.graph && this.graph.destroy();
        },
        methods: {

            showUserInfo(profileId) {
                window.showUserInfo(profileId);
            },

            init() {
                if (window.saveInstance[window.getCurrentPath()]) {
                    window.restoreSaveInstance(window.getCurrentPath(), this.$data);
                } else {
                    this.getData();
                }
            },

            inited() {
                if (this.$route.name == 'flow-detail') {
                    this.setTitle(this.data.title || this.data.approveName || '详情');
                    this.moreButton();
                    console.log('inited', this.time, '==>', this.$route.query.time);
                    if (this.time != this.$route.query.time) {
                        this.time = _.cloneDeep(this.$route.query.time);
                        console.log('inited time ==========>', this.time);
                        for (let key in this.$data) {
                            if (_.isArray(this.$data[key])) {
                                this.$data[key] = [];
                            } else if (_.isObject(this.$data[key])) {
                                this.$data[key] = {};
                            } else if (_.isString(this.$data[key])) {
                                this.$data[key] = '';
                            } else if (_.isInteger(this.$data[key])) {
                                this.$data[key] = 0;
                            }
                        }
                        this.getData();
                    }
                }
            },

            //更多按钮
            moreButton() {
                let options = [];
                if (this.isApprover) {
                    options.push({
                        btnName: '转发',
                        action: 'forward'
                    });
                }
                if (this.data && !this.data.endOperate && !this.data.endType) {
                    options.push({
                        btnName: '再次提交',
                        action: 'submitAgain'
                    });
                }
                window.moreButton({
                    btnName: '更多',
                    children: options
                });
            },

            //获取详情数据
            getData() {
                this.$toast.loading({
                    duration: 0,
                    loadingType: 'spinner',
                    forbidClick: true
                });
                let param = {
                    id: this.$route.query.id
                };
                this.$http.post('badu/eaa/queryApproveWorkFlowDetail_V2.do', param, { toast: true })
                    .then((response) => {
                        this.data = response.data;
                        this.initData();
                    })
                    .catch((error) => {
                        console.log(error);
                        this.indicatorType = error.rspCode == -100 && (error.status != 403 || error.status != 500) ? 1 : 3;
                        this.indicatorMessage = error.rspMsg;
                    });
            },
            //标记已读
            markRead() {
                this.$http.post('badu/eaa/notifyNotifyMeApproveIsRead.do', { ids: this.$route.query.id })
                    .then(() => {
                    });
            },

            //标记转发已读
            markForwardRead() {
                if (this.forwardToMeList.length == 0) {
                    return;
                }
                this.$http.post('badu/eaa/notifyTranspondMeApproveIsRead.do', { ids: this.$route.query.id })
                    .then(() => {
                    });
            },

            //初始化数据
            initData() {
                this.setTitle(this.data.title || this.data.approveName || '详情');
                let tempResult = JSON.parse(this.data.content);
                let tempForm = JSON.parse(this.data.temp.form);
                this.flowData = this.data.temp.process == '[]' ? null : JSON.parse(this.data.temp.process);
                this.rules = [];
                this.rules.push(...this.data.historyProcess);
                if (this.data.nowProcess) {
                    this.data.nowProcess.isNow = true;
                    this.data.nowProcess.createdTime = '';
                    this.rules.push(this.data.nowProcess);
                }
                this.noticeType = this.data.temp.noticeType;
                this.initForward(this.data.transpondList);
                this.initForm(tempForm, tempResult);
            },

            //初始化转发相关数据
            initForward(transpondList) {
                this.forwardFromMeList.splice(0, this.forwardFromMeList.length);
                this.forwardToMeList.splice(0, this.forwardToMeList.length);
                if (!transpondList) {
                    return;
                }
                let currentNodeId = -1;
                if (this.data.nowProcess && this.data.nowProcess.nodeId) {
                    currentNodeId = this.data.nowProcess.nodeId;
                }
                let profileId = this.$store.state.userInfo.profileId;
                for (let i = 0; i < transpondList.length; i++) {
                    let forward = transpondList[i];
                    if (forward.fromProfileId == profileId) {
                        this.forwardFromMeList.push(forward);
                    }
                    if (forward.toProfileId == profileId) {
                        this.forwardToMeList.push(forward);
                        if (forward.nodeId == currentNodeId) {
                            this.canComment = true;
                        }
                    }
                }
                this.markForwardRead();
            },

            onScaleChanged(value) {
                let scale = 5 - (value / 25);
                this.graph.changeSize(320 * scale, 320 * scale);
                this.graph.refresh();
            },

            // 初始化流程图
            initGraph(flow) {
                G6.track(false);
                registerNode(G6);
                this.graph = new G6.Graph({
                    container: 'mountNode',
                    // width: 320,
                    height: 320,
                    pixelRatio: 2,
                    modes: {
                        default: ['drag-canvas', 'zoom-canvas']
                    },
                    fitView: 'autoZoom',
                    fitViewPadding: 15,
                    minZoom: 0.2,
                    maxZoom: 1
                });

                let cavanEdges = [];
                for (let i = 0; i < flow.edges.length; i++) {
                    let edge = flow.edges[i];
                    if (!edge.isBack) {
                        cavanEdges.push(edge);
                    }
                }
                console.log('cavanEdges', cavanEdges);

                for (let i = 0; i < this.data.historyProcess.length; i++) {
                    let rule = this.data.historyProcess[i];
                    console.log('rule', rule);
                    for (let j = 0; j < cavanEdges.length; j++) {
                        let edge = cavanEdges[j];
                        if (edge.source == rule.nodeId && edge.target == rule.doneNodeId) {
                            console.log('highLight', edge);
                            edge.isHighLight = true;
                        }
                    }
                }


                this.graph.edge({
                    // label: 'group',
                    style(model) {
                        if (model.isHighLight) {
                            return {
                                stroke: '#ff0000',
                                fill: '#ff0000'
                            };
                        }
                        return {
                            fill: '#45bf6c',
                            stroke: '#45bf6c'
                        };
                    }
                });
                this.graph.read({
                    nodes: this.flowData.nodes,
                    edges: cavanEdges
                });
            },

            //初始化表单
            initForm(tempForm, tempResult) {
                console.log('initForm', tempForm, tempResult);
                let nodeIds = [];
                let profileId = this.$store.state.userInfo.profileId;

                //判断是否是历史审批人
                for (let i = 0; i < this.data.historyProcess.length; i++) {
                    let item = this.data.historyProcess[i];
                    if (item.type == '1' || item.type == '2' || item.type == '3' || item.type == '6') {
                        for (let j = 0; j < item.approvals.length; j++) {
                            if (profileId == item.approvals[j]) {
                                nodeIds.push(item.nodeId);
                                if (item.type == '2' || item.type == '3' || item.type == '6') {
                                    this.isHistoryApprover = true;
                                }
                                break;
                            }
                        }
                    }
                }

                //判断是否是当前节点审批人
                if (this.data.nowProcess && this.data.nowProcess.approvals) {
                    for (let i = 0; i < this.data.nowProcess.approvals.length; i++) {
                        if (profileId == this.data.nowProcess.approvals[i]) {
                            nodeIds.push(this.data.nowProcess.nodeId);
                            if (this.data.statusCd == 1) {
                                this.isApprover = true;
                            }
                            break;
                        }
                    }
                }
                this.moreButton();

                //是否是发起人
                this.isFromMe = this.data.profileId == this.$store.state.userInfo.profileId;

                //统计抄送人节点
                if (this.data.notifierProcess) {
                    for (let i = 0; i < this.data.notifierProcess.length; i++) {
                        let process = this.data.notifierProcess[i];
                        for (let j = 0; j < process.notifiers.length; j++) {
                            let notifier = process.notifiers[j];
                            if (profileId == notifier) {
                                nodeIds.push(process.nodeId);
                                this.isNotifier = true;
                                break;
                            }
                        }
                    }
                }

                //统计转发节点
                if (this.forwardToMeList && this.forwardToMeList.length) {
                    for (let i = 0; i < this.forwardToMeList.length; i++) {
                        let forward = this.forwardToMeList[i];
                        nodeIds.push(forward.nodeId);
                        break;
                    }
                }

                //是否是归档人
                if (this.data.pigeonholers) {
                    for (let i = 0; i < this.data.pigeonholers.length; i++) {
                        if (this.data.pigeonholers[i].value == this.$store.state.userInfo.profileId) {
                            console.log('this.data.pigeonholers', this.data.pigeonholers[i]);
                            this.isArchiver = true;
                            break;
                        }
                    }
                }

                if (this.$route.query.fromRelate || this.$route.query.formManage) {
                    nodeIds.splice(0, nodeIds.length);
                    if (this.flowData && this.flowData.nodes) {
                        for (let i = 0; i < this.flowData.nodes.length; i++) {
                            nodeIds.push(this.flowData.nodes[i].id);
                        }
                    }
                }

                nodeIds = [...new Set(nodeIds)];

                if ((!nodeIds || nodeIds.length == 0) && !this.isArchiver) {
                    this.indicatorType = 1;
                    this.indicatorMessage = '已有其他或签人员操作或无权查看此审批单';
                    return;
                }

                //根据参与的节点确定查看和编辑权限
                let currentNodeId;
                if (this.data.nowProcess) {
                    currentNodeId = this.data.nowProcess.nodeId;
                }
                let formSetting = {};
                if (this.flowData && this.flowData.nodes) {
                    if (this.flowData.nodes && this.flowData.nodes.length) {
                        for (let i = 0; i < nodeIds.length; i++) {
                            for (let j = 0; j < this.flowData.nodes.length; j++) {
                                let node = this.flowData.nodes[j];
                                if (node.id == nodeIds[i]) {
                                    for (let key in node.form) {
                                        let setting = _.cloneDeep(node.form[key]);
                                        if (node.id != currentNodeId) {
                                            setting.edit = false;
                                            setting.required = false;
                                        }
                                        if (formSetting[key]) {
                                            setting.show = formSetting[key].show || setting.show;
                                            setting.edit = formSetting[key].edit || setting.edit;
                                            setting.required = formSetting[key].required || setting.required;
                                        }
                                        formSetting[key] = setting;
                                    }
                                    break;
                                }
                            }
                        }
                    }
                }

                if (this.isArchiver) {
                    if (this.flowData && this.flowData.nodes) {
                        for (let i = 0; i < this.flowData.nodes.length; i++) {
                            let node = this.flowData.nodes[i];
                            if (node.shape == 'NODE_ARCHIVE') {
                                for (let key in node.form) {
                                    let setting = _.cloneDeep(node.form[key]);
                                    if (node.id != currentNodeId) {
                                        setting.edit = false;
                                        setting.required = false;
                                    }
                                    if (formSetting[key]) {
                                        setting.show = formSetting[key].show || setting.show;
                                        setting.edit = formSetting[key].edit || setting.edit;
                                        setting.required = formSetting[key].required || setting.required;
                                    }
                                    formSetting[key] = setting;
                                }
                                break;
                            }
                        }
                    }
                }

                let temps = [];
                this.editForm = [];
                for (let i = 0; i < tempForm.length; i++) {
                    let component = tempForm[i];
                    if (formSetting[component.props.id]) {
                        component.props.required = formSetting[component.props.id].required;
                        if (formSetting[component.props.id].show) {
                            temps.push(_.cloneDeep(component));
                        }
                        if (formSetting[component.props.id].edit) {
                            this.editForm.push(_.cloneDeep(component));
                        }
                    }
                }
                this.initRelate(temps, tempResult);
                this.result = tempResult;
                let formNew = [];
                this.form = [];
                this.initFormValue(formNew, temps, tempResult);
                this.queryCompanyApproveFormInfo(this.data.approveId).then((msg) => {
                    let labelStr = 'orderStateY';
                    if (this.data.temp && formNew && formNew.length) {
                        formNew.forEach((m) => {
                            m[labelStr] = msg;
                            if (m.componentName === 'TableField' && m.children && m.children.length) { //明细单独判断
                                m.children.forEach((n) => {
                                    if (n && n.length) {
                                        n.forEach((m) => {
                                            m[labelStr] = msg;
                                        });
                                    }
                                });
                            }
                        });
                    }
                }).finally(() => {
                    this.form = formNew;
                    if (this.flowData) {
                        try {
                          this.initGraph(this.flowData);
                        } catch (e) {
                          console.error('e::::::::::', e);
                        }
                    }
                    this.$toast.clear();
                    // console.log('ThisForm', this.form);
                });
            },
            queryCompanyApproveFormInfo(approveId) {
                return new Promise((resolve, reject) => {
                    let param = {
                        id: approveId
                    };
                    this.$http.post('badu/eaa/queryCompanyApproveFormAndProcessSetting.do', param).then((response) => {
                        let info = response.data;
                        if (info.endType) {
                            resolve('ok');
                        } else {
                            resolve('other');
                        }
                    }).catch(() => {
                        // eslint-disable-next-line prefer-promise-reject-errors
                        reject();
                    });
                });
            },
            showProcessInfo(flow) {
                if (flow.approvals && flow.approvals.length == 1) {
                    this.showUserInfo(flow.approvals[0]);
                }
            },

            //获取节点审批人头像
            getProcessPortrait(rule) {
                try {
                    if (rule.approvals) {
                        if (rule.approvals.length == 1) {
                            console.log('getProcessPortrait', rule, this.data.userDetails[rule.approvals[0]]);
                            return this.data.userDetails[rule.approvals[0]].portraitImgUrl;
                        } else if (rule.approvals.length > 1) {
                            return require('../../assets/img/icon/duoren.png');
                            // if (rule.actType == 'or') {
                            //     return require('../../assets/img/icon/duoren.png');
                            // } else if (rule.actType == 'and') {
                            //     return require('../../assets/img/icon/duoren.png');
                            // }
                        }
                    }
                } catch (e) {
                    console.log('getProcessPortrait', e);
                }
                //默认
                return require('../../assets/img/default_portrait.png');
            },

            //根据人员id获取头像
            getPortrait(profileId) {
                return this.data.userDetails[profileId].portraitImgUrl;
            },

            //根据人员id获取名称
            getNotifierName(profileId) {
                if (profileId == this.$store.state.userInfo.profileId) {
                    return '我';
                }
                if (this.data.userDetails[profileId]) {
                    return this.data.userDetails[profileId].realName;
                }
                return '未知';
            },

            //获取节点名称
            getProcessName(rule) {
                if (rule.approvals) {
                    if (rule.approvals.length == 1) {
                        return this.getNotifierName(rule.approvals[0]);
                    } else if (rule.approvals.length > 1) {
                        if (rule.isNow) {
                            return rule.approvals.length + '人';
                        } else if (rule.actType == 'or') {
                            return rule.approvals.length + '人或签';
                        } else if (rule.actType == 'and') {
                            return rule.approvals.length + '人会签';
                        }
                    }
                }
                return '请选择';
            },

            //计算等待时间
            calculateWait(i) {
                if (this.rules[i].isNow) {
                    let subIndex = 1;
                    while (this.rules[i - subIndex]) {
                        if (this.rules[i - subIndex].type == '1' || this.rules[i - subIndex].type == '2' || this.rules[i - subIndex].type == '3') {
                            break;
                        }
                        subIndex += 1;
                    }
                    let msDiff;
                    if (this.rules[i - subIndex].createdTime) {
                        // return moment(this.rules[i - 1].createdTime).fromNow();
                        msDiff = new Date().getTime() - this.rules[i - subIndex].createdTime;
                    } else {
                        msDiff = new Date().getTime() - this.data.createdTime;
                    }
                    // return moment(this.data.createdTime).fromNow();
                    return '已等待 ' + this.diffTime(msDiff);
                } else if (this.rules[i].createdTime) {
                    return moment(this.rules[i].createdTime).format('MM.DD HH:mm');
                }
                return '';
            },

            //差异时间格式化
            diffTime(msDiff) {
                let seconds = Math.floor(msDiff / 1000);
                if (seconds < 60) {
                    return '不到1分钟';
                }
                let minutes = Math.floor(seconds / 60);
                if (minutes < 60) {
                    return minutes + '分钟';
                }
                let hours = Math.floor(minutes / 60);
                if (hours < 24) {
                    return hours + '小时' + minutes % 60 + '分钟';
                }
                return Math.floor(hours / 24) + '天' + hours % 24 + '小时';
            },

            showDialog(type) {
                // window.tempForm = _.cloneDeep(this.data);
                // this.PUSH({ name: 'approve-commit' });
                this.dialogShow = true;
                this.dialogType = type;
                switch (type) {
                    case 3:
                        this.dialogTitle = '你确定要撤销申请吗';
                        break;
                    case 4:
                        this.dialogTitle = '添加评论';
                        break;
                }
            },

            //撤销流程
            recall() {
                this.dialogShow = false;
                this.$toast.loading({
                    duration: 0,
                    loadingType: 'spinner',
                    forbidClick: true
                });
                let param = {
                    id: this.$route.query.id,
                    nodeSort: this.data.currentNodeSort
                };
                this.$http.post('badu/eaa/recallApproveMoving.do', param).then((response) => {
                    this.$toast.clear();
                    if (response.rspCode == 0) {
                        this.$toast.success({
                            duration: 1000,
                            forbidClick: true,
                            message: '撤销成功'
                        });
                        window.refreshList = true;
                        setTimeout(() => {
                            if (window.history.length == 1) {
                                // this.REPLACE({ name: 'approve' });
                                window.closeWindow();
                            } else {
                                this.GO(-1);
                            }
                        }, 1000);
                    } else {
                        this.$toast.fail({
                            duration: 1000,
                            forbidClick: true,
                            message: response.rspMsg
                        });
                    }
                }).catch((error) => {
                    console.log(error);
                    this.$toast.clear();
                });
            },

            //评论
            comment() {
                if (!this.opinionComment.trim()) {
                    this.$toast.fail({
                        duration: 1000,
                        forbidClick: true,
                        message: '请填写评论内容'
                    });
                    return;
                }
                this.dialogShow = false;
                this.$toast.loading({
                    duration: 0,
                    loadingType: 'spinner',
                    forbidClick: true
                });
                let param = {
                    id: this.$route.query.id,
                    content: this.opinionComment
                };
                this.$http.post('badu/eaa/commentApproveMoving.do', param).then(() => {
                    this.$toast.clear();
                    this.opinionComment = '';
                    this.$toast.success({
                        duration: 1000,
                        forbidClick: true,
                        message: '评论成功'
                    });
                    this.getData();
                }).catch((error) => {
                    console.log(error);
                    this.$toast.clear();
                });
            },

            //转发
            forward(profileIds) {
                let param = {
                    id: this.$route.query.id,
                    profileIds: profileIds,
                    nodeId: this.data.nowProcess.nodeId,
                    nodeName: this.data.nowProcess.remark,
                    approveName: this.data.approveName
                };
                console.log('forward', param);
                this.$toast.loading({
                    duration: 0,
                    loadingType: 'spinner',
                    forbidClick: true
                });
                this.$http.post('badu/eaa/transpondApproveWorkflow.do', param).then((response) => {
                    this.$toast.clear();
                    this.$toast.success({
                        duration: 1000,
                        forbidClick: true,
                        message: response.data
                    });
                    setTimeout(() => {
                        this.getData();
                    }, 1000);
                }).catch((error) => {
                    console.log(error);
                    this.$toast.clear();
                    this.$toast.fail({
                        duration: 1000,
                        forbidClick: true,
                        message: error.rspMsg
                    });
                });
            },

            //dialog回调
            beforeClose(action, done) {
                if (action === 'confirm') {
                    done();
                    switch (this.dialogType) {
                        case 3:
                            this.recall();
                            break;
                        case 4:
                            this.comment();
                            break;
                    }
                    // setTimeout(done, 1000);
                    this.dialogType = '';
                } else {
                    done();
                    this.dialogType = '';
                }
            },

            //同意或驳回
            commit(isAgree) {
                if (isAgree) {
                    window.tempData = {
                        form: _.cloneDeep(this.editForm),
                        result: _.cloneDeep(this.result),
                        data: _.cloneDeep(this.data)
                    };
                } else {
                    window.tempData = {
                        result: _.cloneDeep(this.result),
                        data: _.cloneDeep(this.data)
                    };
                }
                this.PUSH({
                    name: 'flow-commit',
                    query: { detailId: this.data.id, isAgree: isAgree }
                });
            },

            //再次提交
            submitAgain() {
                window.tempData = _.cloneDeep(this.result);
                window.tempTitle = _.cloneDeep(this.data.title || this.data.approveName);
                this.PUSH({
                    name: 'flow-create',
                    query: { id: this.data.approveId, title: this.data.approveName, isAgain: true }
                });
            }

        }
    };
</script>

<style lang="scss" scoped
>
    @import '../../assets/scss/approve.scss';
    @import '../../assets/scss/approve-detail.scss';

</style>
